import React from "react";
import { Table } from "semantic-ui-react";

// Interface
import { IssuesTrackingType } from "./sequence/ProjectList";

// Type
type TableIssuesTrackingProps = {
  data: IssuesTrackingType[];
};

const TableIssuesTracking = (props: TableIssuesTrackingProps) => {
  const { data } = props;

  return (
    <Table basic="very" celled compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell />
          <Table.HeaderCell textAlign="center">Open</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Resolved</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Closed</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">Total</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {data.map(({ tracker, open, closed, resolved, total }) => (
          <Table.Row key={tracker}>
            <Table.Cell style={{ fontWeight: "bold", width: "200px" }}>{tracker}</Table.Cell>
            <Table.Cell textAlign="center" style={{ width: "100px" }}>
              {open}
            </Table.Cell>
            <Table.Cell textAlign="center" style={{ width: "100px" }}>
              {resolved}
            </Table.Cell>
            <Table.Cell textAlign="center" style={{ width: "100px" }}>
              {closed}
            </Table.Cell>
            <Table.Cell textAlign="center" style={{ width: "100px" }}>
              {total}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default React.memo(TableIssuesTracking);
